export default __webpack_public_path__ + "static/media/Group18.7971660c.png";